import React from "react";
import ReactDOM from "react-dom";
// import { createRoot } from "react-dom/client";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import App from "./App";

// Used for React 18.0.0
// const container = document.getElementById("root");
// const root = createRoot(container as HTMLElement);
// root.render(<App />, );

// Deprecated Render as of React 18.0.0
ReactDOM.render(<App />, document.getElementById("root"));

// Not using ServiceWorkers :v
//import registerServiceWorker from './registerServiceWorker';
//registerServiceWorker();